import { render, staticRenderFns } from "./notice_list.vue?vue&type=template&id=dd93967a&scoped=true"
import script from "./notice_list.vue?vue&type=script&lang=js"
export * from "./notice_list.vue?vue&type=script&lang=js"
import style0 from "./notice_list.vue?vue&type=style&index=0&id=dd93967a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd93967a",
  null
  
)

export default component.exports